export default {"src":"/_next/static/image/public/images/flags/flag_977.331969ae3af5015faa149628380be67b.svg","height":16,"width":24};